// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3ShzQ","title":"styles_title__29Z5R","data":"styles_data__dCyem"};